import React from "react";

interface Props {
  isCows: boolean;
  isSheep: boolean;
}

export const StartForecastPrompt = ({ isCows, isSheep }: Props) => {
  if (!isCows && !isSheep) return null;
  const livestock = isCows ? "cattle herd" : "sheep flock";
  return (
    <>
      <p>
        Enter your {livestock} details to help forecast financial risks related
        to health risk management.
      </p>
    </>
  );
};
